import React from 'react';
import { Link } from 'react-router-dom';

export function SiteHeader() {
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    const closeOnResize = () => setIsOpen(false);
    window.addEventListener('resize', closeOnResize);
    return () => window.removeEventListener('resize', closeOnResize);
  }, []);

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/80 backdrop-blur-lg">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 text-slate-900">
        <Link
          to="/"
          className="flex items-center gap-3 text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-white"
        >
          <img
            src="/bevpass-letters-blue.svg"
            alt="BevPass"
            className="h-7 w-auto"
            loading="lazy"
          />
        </Link>
        <nav className="hidden items-center gap-8 md:flex">
          <a
            href="#download"
            className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-white"
          >
            Download
          </a>
          <Link
            to="/partners"
            className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-white"
          >
            Become a Merchant
          </Link>
        </nav>
        <button
          type="button"
          onClick={() => setIsOpen((prev) => !prev)}
          className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-600 transition-colors hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-white md:hidden"
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M4 6h16M4 12h16M4 18h16" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
      </div>
      {isOpen && (
        <div className="border-t border-slate-200 bg-white md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-4">
            <a
              href="#download"
              onClick={() => setIsOpen(false)}
              className="text-base font-medium text-slate-600 transition-colors hover:text-slate-900"
            >
              Download
            </a>
            <Link
              to="/partners"
              onClick={() => setIsOpen(false)}
              className="text-base font-medium text-slate-600 transition-colors hover:text-slate-900"
            >
              Become a Merchant
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}

export default SiteHeader;
